import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getLoggedInUser,
  getMyEnterprise,
  loginUser,
  registerAdmin,
  registerMember,
  registerUser,
  registerUserAndEnterprise,
  updateUser,
} from '../../api/constlink';
import {
  getLoggedInUserAsync,
  getMyEnterpriseAsync,
  GET_LOGGED_IN_USER,
  GET_MY_ENTERPRISE,
  loginUserAsync,
  LOGIN_USER,
  registerAdminAsync,
  registerMemberAsync,
  registerUserAndEnterpriseAsync,
  registerUserAsync,
  REGISTER_ADMIN,
  REGISTER_MEMBER,
  REGISTER_USER,
  REGISTER_USER_AND_ENTERPRISE,
  updateUserAsync,
  UPDATE_USER,
} from './actions';
import { Enterprise, LoginResponse, User } from './types';

function* updateUserSaga(action: ReturnType<typeof updateUserAsync.request>) {
  try {
    const user: User = yield call(updateUser, action.payload);
    yield put(updateUserAsync.success(user));
  } catch (e: any) {
    yield put(updateUserAsync.failure(e));
  }
}

function* registerUserSaga(
  action: ReturnType<typeof registerUserAsync.request>,
) {
  try {
    const data: LoginResponse = yield call(registerUser, action.payload);
    localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, data.token);
    yield put(registerUserAsync.success(data.user));
  } catch (e: any) {
    yield put(registerUserAsync.failure(e));
  }
}

function* registerUserAndEnterpriseSaga(
  action: ReturnType<typeof registerUserAndEnterpriseAsync.request>,
) {
  try {
    const data: LoginResponse = yield call(
      registerUserAndEnterprise,
      action.payload,
    );
    localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, data.token);
    yield put(registerUserAndEnterpriseAsync.success(data.user));
  } catch (e: any) {
    yield put(registerUserAndEnterpriseAsync.failure(e));
  }
}

function* loginUserSaga(action: ReturnType<typeof loginUserAsync.request>) {
  try {
    const data: LoginResponse = yield call(loginUser, action.payload);
    localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, data.token);
    yield put(loginUserAsync.success(data.user));
  } catch (e: any) {
    yield put(loginUserAsync.failure(e));
  }
}

function* getLoggedInUserSaga(
  action: ReturnType<typeof getLoggedInUserAsync.request>,
) {
  try {
    const user: User = yield call(getLoggedInUser);
    yield put(getLoggedInUserAsync.success(user));
  } catch (e: any) {
    yield put(getLoggedInUserAsync.failure(e));
  }
}

function* getMyEnterpriseSaga(
  action: ReturnType<typeof getMyEnterpriseAsync.request>,
) {
  try {
    const enterprise: Enterprise = yield call(getMyEnterprise, action.payload);
    yield put(getMyEnterpriseAsync.success(enterprise));
  } catch (e: any) {
    yield put(getMyEnterpriseAsync.failure(e));
  }
}

function* registerMemberSaga(
  action: ReturnType<typeof registerMemberAsync.request>,
) {
  try {
    const data: LoginResponse = yield call(registerMember, action.payload);
    /**
     * 직원은 회원가입 완료 후 다시 로그인 해야 한다
     */
    // localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, data.token);
    yield put(registerMemberAsync.success(data.user));
  } catch (e: any) {
    yield put(registerMemberAsync.failure(e));
  }
}

function* registerAdminSaga(
  action: ReturnType<typeof registerAdminAsync.request>,
) {
  try {
    const data: LoginResponse = yield call(registerAdmin, action.payload);
    localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, data.token);
    yield put(registerAdminAsync.success(data.user));
  } catch (e: any) {
    yield put(registerAdminAsync.failure(e));
  }
}

export function* authSaga() {
  yield takeLatest(UPDATE_USER, updateUserSaga);
  yield takeLatest(REGISTER_USER, registerUserSaga);
  yield takeLatest(REGISTER_USER_AND_ENTERPRISE, registerUserAndEnterpriseSaga);
  yield takeLatest(LOGIN_USER, loginUserSaga);
  yield takeLatest(GET_LOGGED_IN_USER, getLoggedInUserSaga);
  yield takeLatest(GET_MY_ENTERPRISE, getMyEnterpriseSaga);
  yield takeLatest(REGISTER_MEMBER, registerMemberSaga);
  yield takeLatest(REGISTER_ADMIN, registerAdminSaga);
}
